import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import HighchartsChart from '../HighchartsChart';
import Options3d from '../Options3d';
var CHART = {
  options3d: {
    enabled: true
  }
};
var ZAXIS = {
  id: 'zAxis'
};

var Highcharts3dChart = function Highcharts3dChart(_ref) {
  var children = _ref.children,
      alpha = _ref.alpha,
      axisLabelPosition = _ref.axisLabelPosition,
      beta = _ref.beta,
      depth = _ref.depth,
      fitToPlot = _ref.fitToPlot,
      frame = _ref.frame,
      viewDistance = _ref.viewDistance,
      rest = _objectWithoutProperties(_ref, ["children", "alpha", "axisLabelPosition", "beta", "depth", "fitToPlot", "frame", "viewDistance"]);

  return /*#__PURE__*/React.createElement(HighchartsChart, _extends({
    chart: CHART,
    zAxis: ZAXIS
  }, rest), /*#__PURE__*/React.createElement(Options3d, {
    alpha: alpha,
    axisLabelPosition: axisLabelPosition,
    beta: beta,
    depth: depth,
    fitToPlot: fitToPlot,
    frame: frame,
    viewDistance: viewDistance
  }), children);
};

export default Highcharts3dChart;